import { Box, Group, Loader, Stack, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useGetConvites from "@/components/app-container/useGetConvites";
import useQuickIdeaMode from "@/hooks/useQuickIdeaMode";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import { TIdeiaForm } from "@/modules/ideias/firestore";
import ideiaSchema from "@/modules/ideias/schema/ideia-schema";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import AddIdeiaButton from "./AddIdeiaButton";
import CampanhaDeInovacao from "./CampanhaDeInovacao";
import CronogramasDeDesafiosCard from "./CronogramasDeDesafios";
import TopDesafiosMaisVotadasCard from "./TopDesafiosMaisVotadasCard";
import TopIdeiasMaisVotadasCard from "./TopIdeiasMaisVotadasCard";
import UltimasIdeiasAtualizadasCard from "./UltimasIdeiasAtualizadasCard";
import UltimosDesafiosAtualizadasCard from "./UltimosDesafiosAtualizadasCard";

// prettier-ignore
const GestaoInovacaoPage = () => {
  const { data, isLoading } = useGetConvites();
  const empresa = useUserStore((state) => state.activeEmpresa);
  const uid = getCurrentUser()?.uid;
  const { data: colaborador } = useGetColaboradorById(empresa?.id || "", uid || "")
  const navigate = useNavigate();
  const isSmMarches = useMediaQuery("(max-width: 48em)");

  // Quick idea mode - detect if user came from QR Code
  const { isQuickMode, regulamentoId, clearQuickMode } = useQuickIdeaMode();

  // Auto-open idea form modal when in quick mode
  useEffect(() => {
    if (isQuickMode && colaborador) {
      const defaultValues = ideiaSchema.getDefault() as TIdeiaForm;

      // Open the idea form modal
      modals.openContextModal({
        modal: "ideia-form-modal",
        size: "xl",
        closeOnClickOutside: false,
        closeOnEscape: false,
        innerProps: {
          item: {
            ...defaultValues,
            regulamentoReference: regulamentoId || ""
          },
          quickMode: true,
          onCloseCallback: () => {
            clearQuickMode();
            navigate("/ideias");
          }
        }
      });

      // Clean up quick mode flag after opening
      clearQuickMode();
    }
  }, [isQuickMode, colaborador, regulamentoId, clearQuickMode, navigate]);

  useEffect(() => {
    if (data && data.length > 0 && colaborador?.role !== "ADMIN") {
      navigate("/diagnosticoEmpresa");
    }
  }, [data?.length])


  if (isLoading && colaborador?.role !== "ADMIN") {
    return (
      <Box pos="relative" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <Loader />
      </Box>
    );
  }

  if (colaborador?.gestao === false && colaborador?.role !== "ADMIN") {
    return (
      <Box pos="relative" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <Text fw={"bold"}>Você não possui acesso a este módulo. Navegue para aquele ao qual você possui acesso.</Text>
      </Box>
    );
  }
  return (
    <Stack gap="md">
      <AddIdeiaButton />
      <Group w={"100%"} justify="space-between" style={{ flexWrap: isSmMarches ? "wrap" : "nowrap" }}>
        <TopIdeiasMaisVotadasCard />
        <CampanhaDeInovacao />
      </Group>
      <UltimasIdeiasAtualizadasCard />
      <Group w={"100%"} justify="space-between" style={{ flexWrap: isSmMarches ? "wrap" : "nowrap" }}>
        <TopDesafiosMaisVotadasCard />
        <CronogramasDeDesafiosCard />
      </Group>
      <UltimosDesafiosAtualizadasCard />
    </Stack>
  );
};

export default GestaoInovacaoPage;
